import sanityClient from '@sanity/client'

export default sanityClient({
	projectId: "q4xdfp1l",
	dataset: "production",
})
